import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Policies.css";

export default function ContentPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="ijacna-policy-page-container">
      <header className="ijacna-policy-page-header">
        <h1>Content Policies</h1>
        <p>
          IJACNA enforces strict editorial and ethical policies to maintain the
          integrity and authenticity of its published content.
        </p>
      </header>

      <section className="ijacna-policy-section">
        <h2>Editorial Guidelines</h2>
        <ul>
          <li>All manuscripts undergo rigorous double-blind peer review.</li>
          <li>Authors must ensure originality and avoid plagiarism.</li>
          <li>Conflict of interest must be declared at submission.</li>
        </ul>
      </section>

      <section className="ijacna-policy-section alt-bg">
        <h2>Corrections and Retractions</h2>
        <ul>
          <li>
            IJACNA will issue corrections or retractions if errors are
            identified post-publication.
          </li>
          <li>Fraudulent or unethical works may be removed from archives.</li>
          <li>All changes will be recorded transparently on the website.</li>
        </ul>
      </section>

      <div className="ijacna-policy-back-button-container">
        <Link to="/policies" className="ijacna-policy-back-button">
          ← Back to Policies
        </Link>
      </div>
    </div>
  );
}
